import { useMemo } from 'react';

export const usePageSizes = (pageSizeOptions: number[]) => {
  return useMemo(() => {
    return pageSizeOptions.map((value) => ({ label: value, value }));
  }, [pageSizeOptions]);
};
